import React, { useEffect, useRef } from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";

export const TerminalBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // Solid dark hacker black background
    ctx.fillStyle = "#020402";
    ctx.fillRect(0, 0, width, height);

    // Draw scanlines (horizontal thin lines)
    ctx.strokeStyle = "rgba(0, 255, 0, 0.03)";
    ctx.lineWidth = 2;
    for (let y = 0; y < height; y += 8) {
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(width, y);
      ctx.stroke();
    }

    // Scrolling CRT green sweeping line
    const sweepY = (frame * 6) % height;
    const sweepGrad = ctx.createLinearGradient(0, sweepY - 150, 0, sweepY);
    sweepGrad.addColorStop(0, "rgba(0, 255, 0, 0)");
    sweepGrad.addColorStop(1, "rgba(0, 255, 0, 0.04)");

    ctx.fillStyle = sweepGrad;
    ctx.fillRect(0, sweepY - 150, width, 150);

    // Draw ambient monospace green matrix rain code lines in background
    ctx.fillStyle = "rgba(0, 255, 0, 0.02)";
    ctx.font = "14px 'JetBrains Mono', monospace";
    const codeLines = [
      "sys_init: loading matrix elements...",
      "decrypting packets: [OK]",
      "antigravity_core: connected",
      "npm run generate: compiling reel...",
      "remotion_renderer: caching assets...",
      "buffer stitched: 44.1kHz Float32 [OK]",
      "process.env.THEME = 'retro-terminal'",
    ];

    for (let i = 0; i < codeLines.length; i++) {
      ctx.fillText(codeLines[i], 50, 100 + i * 40);
      ctx.fillText(
        codeLines[(i + 3) % codeLines.length],
        width - 400,
        height - 300 + i * 40,
      );
    }
  }, [frame, width, height]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1,
      }}
    />
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
